'use strict';

const submitEvent = 'submit';
const preSubmitEvent = 'ds:pre:submit';

const sentinelName = '__serialisedFieldsList';
const fieldSelector = '.encoded-field';

const fields = $(fieldSelector);

const mce = global.tinyMCE;

function encodeBase64(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode(parseInt(p1, 16))
    }));
}

function encodeForTransmission(str) {
    return encodeURIComponent(encodeBase64(str));
}

if (fields.length > 0) {
    const listeners = $(fieldSelector).map((index, field) => {
        // Map each field to a deferred object so that we can subscribe do the bunch
        // of future values.
        return $.Deferred((futureValue) => {
            // Subscribe to the pre-submit event so we can change the field's value.
            $(field).on(preSubmitEvent, () => {
                const input = $(field);
                const richTextField = $(field).hasClass('tinymce');

                if (richTextField) {
                    const editor = mce.get($(field).attr('id'));
                    editor.setContent(encodeForTransmission(editor.getContent()));
                } else {
                    input.val(encodeForTransmission(input.val()));
                }

                futureValue.resolve();
            }).promise();
        });
    });

    let $form = null;
    fields.each((index, field) => {
        const $field = $(field);
        const parent = $field.parents('form');

        // Attach one submit subscriber per parent form, in case multiple fields to be
        // serialised exists under different FORM nodes.
        let $parent = $(parent).get(0);
        if ($form !== $parent) {
            // Subscribe to the form's submit event.
            parent.on(submitEvent, (e) => {
                // TODO: Can I restate this closure so that $?parent is NOT coming from the outer scope? This to avoid funny dynamic binding stuff.
                e.stopPropagation();

                // Trigger the pre-submit event to notify all field's listeners to encode the content.
                parent.find(fieldSelector).trigger(preSubmitEvent);

                // Compile the list of fields that have been encoded.
                const list = parent.find(fieldSelector)
                    .map((index, field) => $(field).attr('name'))
                    .get();

                let sentinel = parent.find(`input[name*="${sentinelName}"]`);

                // Inject the list.
                sentinel.val(list.join());

                $.when(...listeners).then(() => {
                    $parent.submit();
                });
            });

            // Hold a reference, to compare with other forms on the page.
            $form = $parent;
        }
    });
}



// WEBPACK FOOTER //
// ./src/js/components/waf-preventer.js